module.exports = __webpack_public_path__ + "static/img/2.4722e17.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/2/1/zh/2.png
// module id = bnWT
// module chunks = 0